import './alert_config';
import './load_patients';
import './pharmacy_group_upload';
